import { Flex } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { BasicProfile } from "PFTypes";

import css from "./workforce_member_cell.module.scss";

type WorkforceMemberCellProps = {
  profile: BasicProfile;
};

export const WorkforceMemberCell = ({ profile }: WorkforceMemberCellProps) => {
  const profileFullName = getProfileName(profile);
  const title = `${profileFullName} ${profile.email}`;

  return (
    <Flex direction="column" justifyContent="start" gap={null} className={css.root} title={title}>
      <Typography withMargin variant="bodyBold" tag="span">
        {profileFullName}
      </Typography>
      <Typography withMargin variant="labelRegular" tag="span" clipOverflow>
        {profile.email}
      </Typography>
    </Flex>
  );
};
